import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TitleHeaderHook } from '../hooks/titleHeaderHook';

function HeaderTitle(props) {
  const { timePassed, titleTicket } = TitleHeaderHook(props);
  return (
    <Grid container className='page-header ticket-detail' width={'97%'}>
      <Grid
        item
        size={{ xs: 6 }}
        textAlign={'start'}
        display='flex'
        alignItems='center'
        paddingTop={'15px'}
      >
        <a href='/my-tickets'>
          <ArrowBackIosIcon className={'icon'} />
        </a>
        <h3>{titleTicket}</h3>
      </Grid>
      <Grid item size={{ xs: 6 }} display='flex' justifyContent='flex-end'>
        <div className='counter' style={{ textAlign: 'end' }}>
          <Button
            disabled
            variant='outlined'
            className='item'
            sx={{
              '&.Mui-disabled': {
                color: '#591a64',
              },
            }}
          >
            Abierto hace: {timePassed}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
}

export default HeaderTitle;
